// client/src/coms/components/mobile/MobileMoreSheet.js
// Phones: "More" in a navigation bar. Every destination the bar does not show (nav = the buttons shown), plus a
// shortcut to Mobile Layout.
import React, { useEffect, useRef } from 'react';
import { moreDestinations } from '../../personalisation/mobileLayout';
import { NavGlyph } from './MobileNavBar';

export default function MobileMoreSheet({ nav, style = 'icons-labels', onNavigate, onClose, onCustomise }) {
  const glyphStyle = style.startsWith('emoji') ? 'emoji-labels' : style === 'labels' ? 'labels' : 'icons-labels';
  const ref = useRef(null);
  useEffect(() => {
    const first = ref.current && ref.current.querySelector('button');
    if (first) first.focus();
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div className="vx-msheet-backdrop" onClick={(e) => e.target === e.currentTarget && onClose()} data-testid="mobile-more">
      <div className="vx-msheet" role="dialog" aria-modal="true" aria-label="More" ref={ref}>
        <div className="vx-msheet-grip" aria-hidden="true" />
        <div className="vx-msheet-grid">
          {moreDestinations(nav).map((o) => (
            <button key={o.id} type="button" className="vx-msheet-item" onClick={() => onNavigate(o.id)} data-testid={`mobile-more-${o.id}`}>
              <NavGlyph id={o.id} variant={glyphStyle} size={24} />
            </button>
          ))}
        </div>
        <button type="button" className="vx-btn small vx-msheet-customise" onClick={onCustomise} data-testid="mobile-more-customise">
          Customise navigation…
        </button>
      </div>
    </div>
  );
}
